var Buffer = require('buffer/').Buffer;
export class ZipManagerV1Impl {
    constructor() {
        this.listeners = new Set();
        this.zipcookiename = 'user_zip';
        this.locationAuthCookieName = 'allow_browser_location';
        this.zipCookieAddress = 'user_zip_address';
        this.setLocationAuth = () => {
            try {
                if (navigator.geolocation) {
                    navigator.geolocation.watchPosition(() => {
                        this.setLocationAuthCookie('allow');
                    }, (error) => {
                        if (error.code === error.PERMISSION_DENIED) {
                            this.setLocationAuthCookie('block');
                        }
                    });
                }
            }
            catch (error) {
                console.log('SET LOCATION COOKIE ERROR:: ', error);
            }
        };
        this.zip = '';
        this.ipZip = '';
        this.zipModalActive = false;
        this.zipLat = 0.0;
        this.zipLng = 0.0;
        this.state = '';
        this.city = '';
    }
    getState() {
        return this.state;
    }
    setState(state) {
        this.state = state;
    }
    getCity() {
        return this.city;
    }
    setCity(city) {
        this.city = city;
    }
    getZipLat() {
        return this.zipLat;
    }
    setZipLat(zipLat) {
        this.zipLat = zipLat;
    }
    getZipLon() {
        return this.zipLng;
    }
    setZipLng(zipLng) {
        this.zipLng = zipLng;
    }
    getZip() {
        return this.zip;
    }
    setZip(zip) {
        this.zip = zip;
        this.notifyListeners();
    }
    getZipModalActive() {
        return this.zipModalActive;
    }
    setZipModalActive(zipModalActive) {
        this.zipModalActive = zipModalActive;
    }
    getIpZip() {
        return this.ipZip;
    }
    setIpZip(zip) {
        this.ipZip = zip;
    }
    getZipCookie() {
        return this.getCookie(this.zipcookiename);
    }
    getLocationAuthCookie() {
        return this.getCookie(this.locationAuthCookieName);
    }
    getZipCookieAddress() {
        return this.getCookie(this.zipCookieAddress);
    }
    setZipCookie(zip) {
        this.deleteZipCookie();
        const endDate = new Date();
        endDate.setMonth(endDate.getMonth() + 1);
        document.cookie = `${this.zipcookiename}=${zip}; expires=${endDate}; path=/`;
        this.setZip(zip);
    }
    setLocationAuthCookie(permission) {
        this.deleteLocationAuthCookie();
        const endDate = new Date();
        endDate.setMonth(endDate.getMonth() + 1);
        document.cookie = `${this.locationAuthCookieName}=${permission}; expires=${endDate}; path=/`;
    }
    setZipCookieAddress(address) {
        this.deleteZipCookieAddress();
        const endDate = new Date();
        endDate.setMonth(endDate.getMonth() + 1);
        document.cookie = `${this.zipCookieAddress}=${address}; expires=${endDate}; path=/`;
    }
    deleteZipCookie() {
        document.cookie =
            this.zipcookiename + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
    deleteLocationAuthCookie() {
        document.cookie =
            this.locationAuthCookieName +
                '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
    deleteZipCookieAddress() {
        document.cookie =
            this.zipCookieAddress +
                '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
    /*
    * Updates Zip and validates against google api key. (Assumes goole scrip is in place if not throws and error)
    */
    async updateZipInformation(urlZip, ipZip) {
        const result = {
            status: false,
            response: '',
        };
        const getResult = (pZip, pStatus) => {
            this.setZip(pZip);
            this.setIpZip(ipZip);
            result.status = pStatus;
            result.response = this.getZipCookie();
            return result;
        };
        return new Promise((resolve, reject) => {
            if (this.getZipCookie()) {
                resolve(getResult(urlZip ? urlZip : this.getZipCookie(), true));
            }
            else if (!urlZip &&
                (!this.getLocationAuthCookie() ||
                    this.getLocationAuthCookie() === 'allow')) {
                this.detectBrowserLocation(true)
                    .then(() => {
                    resolve(getResult(urlZip ? urlZip : this.getZip(), true));
                })
                    .catch((error) => {
                    console.log('Errors fetching detectBrowserLocation:' + error);
                    reject(getResult(urlZip ? urlZip : ipZip, false));
                })
                    .finally(() => {
                    this.setLocationAuth();
                });
            }
            else {
                resolve(getResult(urlZip ? urlZip : ipZip, true));
            }
        });
    }
    /*
    * Save the zip and coordinates on  the service
    */
    updateZipCoordinates(zip, lat, lng) {
        const result = {
            status: false,
            response: '',
        };
        this.setZip(zip);
        this.setZipLat(lat);
        this.setZipLng(lng);
        result.status = true;
        result.response = zip;
        this.notifyListeners();
        return result;
    }
    createAuthorizationHeader(username, password) {
        if (!password || !username) {
            return undefined;
        }
        return {
            Authorization: `Basic ${Buffer.from(`${username}:${password}`).toString('base64')}`
        };
    }
    /*
  * Get Coordinates from Browser y user allows it and set the cookie that he allow it
  */
    async detectUserCoodinates() {
        const result = {
            status: false,
            coordinates: {
                lat: 0.0,
                lng: 0.0
            },
            response: ''
        };
        if (!this.getLocationAuthCookie() ||
            this.getLocationAuthCookie() === '' ||
            this.getLocationAuthCookie() === 'allow') {
            const mainPromise = () => {
                return new Promise((resolve, reject) => {
                    if (navigator.geolocation) {
                        const onSuccess = (position) => {
                            result.status = true;
                            result.coordinates = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            };
                            //this.notifyListeners();
                            resolve(result);
                        };
                        const onFailure = (err) => {
                            result.response =
                                'Geolocation ERROR: Geolocation not allowed: ' + err;
                            reject(result);
                        };
                        try {
                            //hack to force work the timeout
                            navigator.geolocation.getCurrentPosition(function () { }, function () { }, {});
                            navigator.geolocation.getCurrentPosition(onSuccess, onFailure, {
                                timeout: 10000,
                            });
                        }
                        catch (error) {
                            result.response = 'Geolocation ERROR : Could not fetch the lat long';
                            reject(result);
                        }
                    }
                    else {
                        result.response =
                            'Geolocation ERROR: Geolocation not allowed or browser too old';
                        reject(result);
                    }
                });
            };
            const promiseTimeout = function (ms, promise) {
                // Create a promise that rejects in <ms> milliseconds
                let timeout = new Promise((resolve, reject) => {
                    let id = setTimeout(() => {
                        clearTimeout(id);
                        reject('Timed out in ' + ms + 'ms.');
                    }, ms);
                    console.log(resolve);
                });
                // Returns a race between our timeout and the passed in promise
                return Promise.race([
                    promise,
                    timeout
                ]);
            };
            // Apply a timeout of 5 seconds to doSomething
            return promiseTimeout(5000, mainPromise());
        }
        else {
            return new Promise((resolve) => {
                result.status = false;
                result.response =
                    'Geolocation ERROR: Geolocation not allowed or browser too old';
                result.coordinates = {
                    lat: 0.0,
                    lng: 0.0
                };
                resolve(result);
            });
        }
    }
    /*
      Assumes the app that calls the service has set windows.google.maps.Geocoder. In other words, has the script
       <script async="" src="https://maps.googleapis.com/maps/api/js?callback=_$_google_map_initialize_$_&amp;key={key}"></script>
    */
    async detectBrowserLocation(storeZip) {
        const result = {
            status: false,
            response: '',
        };
        const mainPromise = () => {
            return new Promise((resolve, reject) => {
                if (navigator.geolocation) {
                    const onSuccess = (position) => {
                        const timeout = 5000; // ms to wait for google API to load after getting local geolocation. API could load before lat
                        let timetaken = 0;
                        const waiter = () => {
                            if (window &&
                                window.google &&
                                window.google.maps &&
                                window.google.maps.Geocoder) {
                                try {
                                    const geocoder = new google.maps.Geocoder();
                                    const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                                    geocoder.geocode({
                                        latLng: latlng,
                                    }, (results, status) => {
                                        try {
                                            window.res = results;
                                            // x is a throwaway variable here and each step could evaulate to falsey. That's why I'm assigning in the conditional.
                                            let x = null;
                                            if (status === google.maps.GeocoderStatus.OK &&
                                                Array.isArray(results)) {
                                                x = results.find((el) => JSON.stringify(el).indexOf('postal_code') >= 0);
                                                if (x) {
                                                    let postalCodeReg = x.address_components.find((el) => el.types[0] === 'postal_code');
                                                    if (postalCodeReg && /^(\d{5})$/.test(postalCodeReg.long_name || '')) {
                                                        postalCodeReg = RegExp.$1;
                                                        if (postalCodeReg) {
                                                            if (storeZip) {
                                                                this.setZip(postalCodeReg);
                                                                if (x.geometry && x.geometry.location && x.geometry.location.lat) {
                                                                    this.setZipLat(x.geometry.location.lat);
                                                                }
                                                                if (x.geometry && x.geometry.location && x.geometry.location.lng) {
                                                                    this.setZipLat(x.geometry.location.lat);
                                                                }
                                                            }
                                                            result.status = true;
                                                            result.response = postalCodeReg;
                                                            this.notifyListeners();
                                                            resolve(result);
                                                        }
                                                        else {
                                                            reject(result);
                                                        }
                                                    }
                                                    else {
                                                        reject(result);
                                                    }
                                                }
                                                else {
                                                    reject(result);
                                                }
                                            }
                                            else {
                                                reject(result);
                                            }
                                        }
                                        catch (err) {
                                            reject(result);
                                        }
                                    });
                                }
                                catch (err) {
                                    reject(result);
                                }
                            }
                            else if (timetaken <= timeout) {
                                console.log('Geolocation ERROR : Waiting...');
                                setTimeout(() => {
                                    waiter();
                                }, 200);
                                result.response = 'Geolocation ERROR: time out';
                                timetaken += 200;
                            }
                            else {
                                reject(result);
                            }
                        };
                        waiter();
                    };
                    const onFailure = (err) => {
                        result.response =
                            'Geolocation ERROR: Geolocation not allowed: ' + err;
                        reject(result);
                    };
                    try {
                        //hack to force work the timeout
                        navigator.geolocation.getCurrentPosition(function () { }, function () { }, {});
                        navigator.geolocation.getCurrentPosition(onSuccess, onFailure, {
                            timeout: 10000,
                        });
                    }
                    catch (error) {
                        result.response = 'Geolocation ERROR : Could not fetch the lat long';
                        reject(result);
                    }
                }
                else {
                    result.response =
                        'Geolocation ERROR: Geolocation not allowed or browser too old';
                    reject(result);
                }
            });
        };
        const promiseTimeout = function (ms, promise) {
            // Create a promise that rejects in <ms> milliseconds
            let timeout = new Promise((resolve, reject) => {
                let id = setTimeout(() => {
                    clearTimeout(id);
                    reject('Timed out in ' + ms + 'ms.');
                }, ms);
                console.log(resolve);
            });
            // Returns a race between our timeout and the passed in promise
            return Promise.race([
                promise,
                timeout
            ]);
        };
        // Apply a timeout of 5 seconds to doSomething
        return promiseTimeout(3000, mainPromise());
    }
    /*
      Based on the service config, calls the empty page {service-config-host}/en/geolocation-zip.html to get the zip of the user
      from a service provided by the cache service dynalight
    */
    async getZipByIp(storeZip, iPtoZip) {
        let result = {
            status: false,
            response: '',
        };
        const ipToZipUrl = iPtoZip.urlOrigin + iPtoZip.urlPath;
        let serviceAuthHeader = undefined;
        if (iPtoZip.credentials) {
            const { credentials } = iPtoZip;
            serviceAuthHeader = this.createAuthorizationHeader(credentials === null || credentials === void 0 ? void 0 : credentials.username, credentials === null || credentials === void 0 ? void 0 : credentials.password);
        }
        try {
            const responseIptoZip = await fetch(ipToZipUrl, {
                method: 'GET',
                mode: 'cors',
                headers: Object.assign({}, serviceAuthHeader),
            });
            if (responseIptoZip.ok && responseIptoZip.headers.get("x-user-zip")) {
                this.ipZip = responseIptoZip.headers.get("x-user-zip");
                if (storeZip) {
                    this.setZip(this.ipZip);
                }
                result.status = true;
                result.response = this.ipZip;
                this.notifyListeners();
                console.log('getZipByIp():' + result.response);
            }
            else {
                result.status = false;
                result.response = "No Zip on the CDN or bad request";
            }
        }
        catch (err) {
            result.status = false;
            console.log("Something went wrong fetching the iptozip service", err);
            result.response = "Something went wrong fetching the iptozip service";
        }
        console.log('getZipByIp():' + result.response);
        return result;
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }
    getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (const value of ca) {
            let c = value;
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
    notifyListeners() {
        this.listeners.forEach((listener) => listener());
    }
}
